import { catchError, firstValueFrom, of, throwError, timeout } from "rxjs";

import { OverviewService } from "../../../../../apis/surfdomeinen/services";
import { CollectorCallbackParams } from "../collector-callback";

export async function CollectorDomain(
  service: OverviewService,
  customerId: string,
  callback: (data: CollectorCallbackParams) => void,
) {
  const obs = service.listNames({ organisation_id: customerId, exclude_subzones: true }).pipe(
    // make the operation time-out if this observable never completes.
    // this can happen if the API throws an error (for authentication reasons, ...)
    timeout({
      first: 5_000,
      with: () => throwError(() => new Error("Operation timed out")),
    }),
    // catch the error (either timeout or the API error) and return an empty list.
    // maybe also display something to the user?
    catchError((err) => {
      const { status, statusText } = err;
      return of(`(${status}) ${statusText}`);
    }),
  );

  const domainList: string = await firstValueFrom(obs);
  const callbackParams: CollectorCallbackParams = {
    data: domainList,
    error: undefined,
  };

  // output from this call is always a string.
  // trust the fact that a space cannot be present in a domainname..
  if (domainList.indexOf(" ") !== -1) {
    callbackParams["error"] = new Error(domainList);
  }
  callback(callbackParams);
}
